/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ForgotPasswordProps, HeaderProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "ForgotPasswordPageService";
const log: any = LoggerModule.getInstance();

export class ForgotPasswordPageService {
  private static instance: ForgotPasswordPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: HeaderProps;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): ForgotPasswordPageService {
    if (!ForgotPasswordPageService.instance) {
      ForgotPasswordPageService.instance = new ForgotPasswordPageService(props);
    }
    return ForgotPasswordPageService.instance;
  }

  public async forgotPassword(args: ForgotPasswordProps) {
    log.info(`user SignIn`, args);
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getForgotPassword(_args);
  }
}
